<div class="modal fade" [class.show]="visible" [style.display]="visible ? 'block' : 'none'" tabindex="-1" role="dialog" aria-labelledby="templateSaveModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="templateSaveModalLabel">
          <i class="fas fa-save me-2"></i>
          Salva Template
        </h5>
        <button type="button" class="btn-close" (click)="onCancel()" aria-label="Close"></button>
      </div>

      <form [formGroup]="templateForm" (ngSubmit)="onSave()">
        <div class="modal-body">
          <div class="mb-3">
            <label for="templateName" class="form-label font-semibold"> Nome Template <span class="text-danger">*</span> </label>
            <input type="text" id="templateName" class="form-control" [class.is-invalid]="isFieldInvalid('name')" formControlName="name" placeholder="Es: Layout Articolo News" maxlength="100" />
            @if (isFieldInvalid('name')) {
              <div class="invalid-feedback">
                {{ getFieldError('name') }}
              </div>
            }
            <small class="form-text text-muted"> {{ templateForm.get('name')?.value?.length || 0 }}/100 caratteri </small>
          </div>

          <div class="mb-3">
            <label for="templateDescription" class="form-label font-semibold"> Descrizione (opzionale) </label>
            <textarea id="templateDescription" class="form-control" [class.is-invalid]="isFieldInvalid('description')" formControlName="description" rows="3" placeholder="Descrizione del template..." maxlength="500"></textarea>
            @if (isFieldInvalid('description')) {
              <div class="invalid-feedback">
                {{ getFieldError('description') }}
              </div>
            }
            <small class="form-text text-muted"> {{ templateForm.get('description')?.value?.length || 0 }}/500 caratteri </small>
          </div>

          <div class="mb-3">
            <label class="form-label font-semibold">Tipo di Template</label>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="templateType" id="structureOnly" value="structure_only" formControlName="type" />
              <label class="form-check-label" for="structureOnly">
                <strong>Solo Struttura</strong>
                <small class="d-block text-muted">Salva solo la disposizione dei blocchi (senza testi e immagini)</small>
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" name="templateType" id="withContent" value="with_content" formControlName="type" />
              <label class="form-check-label" for="withContent">
                <strong>Con Contenuto</strong>
                <small class="d-block text-muted">Salva struttura e contenuti (testi, immagini, ecc.)</small>
              </label>
            </div>
          </div>

          @if (templateForm.get('type')?.value) {
            <div class="alert alert-info">
              <i class="fas fa-info-circle me-2"></i>
              @if (templateForm.get('type')?.value === 'structure_only') {
                <strong>Solo Struttura:</strong> Il template salverà la disposizione dei blocchi ma non i contenuti. Quando lo userai, dovrai inserire nuovi testi e immagini.
              } @else {
                <strong>Con Contenuto:</strong> Il template salverà tutto il contenuto attuale. Quando lo userai, potrai modificare testi e immagini esistenti.
              }
            </div>
          }
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" (click)="onCancel()" [disabled]="loading()">Annulla</button>
          <button type="submit" class="btn btn-primary" [disabled]="templateForm.invalid || loading()">
            @if (loading()) {
              <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            }
            <i class="fas fa-save me-2"></i>
            Salva Template
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

@if (visible) {
  <div class="modal-backdrop fade show"></div>
}
